import { Add } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionDetails, AccordionSummary, FormLabel, Stack } from '@mui/material';
import CustomAccordion from 'common/components/CustomAccordion';
import CustomIconButton from 'common/components/CustomIconButton';
import CustomTooltip from 'common/components/CustomTooltip';
import useFlexBoxStyles from 'common/flexBox';
import { useEffect, useState } from 'react';

const EventFormCollapse = (props) => {
    const {
        children,
        sectionTitle,
        hideExpand,
        selectAsset,
        addButtonText,
        expanded,
        hideAdd = false,
        canExpand = true,
        searchControl,
    } = props;

    const { classes: flexBox, cx } = useFlexBoxStyles();

    const [expandedAccordion, setExpandedAccordion] = useState(false);

    const handleOnChange = (event, expanded) => {
        if (!expanded || canExpand) {
            setExpandedAccordion(expanded);
        }
    };

    useEffect(() => {
        setExpandedAccordion(expanded);
    }, [expanded]);

    return (
        <CustomAccordion
            defaultExpanded={expanded}
            disableGutters
            onChange={handleOnChange}
            expanded={expandedAccordion}
        >
            <AccordionSummary
                expandIcon={!hideExpand ? <ExpandMoreIcon /> : <div style={{ width: '18px' }}></div>}
                aria-controls="panel1a-content"
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    className={cx(flexBox.w100, !hideExpand && flexBox.marginRight1)}
                >
                    <FormLabel>{sectionTitle}</FormLabel>
                    <Stack direction="row" spacing={1}>
                        {expandedAccordion && searchControl}
                        {!hideAdd && (
                            <Stack direction="row">
                                <CustomTooltip arrow title={addButtonText} placement={'bottom'}>
                                    <CustomIconButton size="small" onClick={selectAsset}>
                                        <Add component="svg" />
                                    </CustomIconButton>
                                </CustomTooltip>
                            </Stack>
                        )}
                    </Stack>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </CustomAccordion>
    );
};

export default EventFormCollapse;
